import { getRoutes } from "shared/routing/routes";
import { config } from "./main";

const sharedRoutes = getRoutes("Эдеон");

const baseRoutes = sharedRoutes[0];
baseRoutes.children.push(
  {
    path: "/categories",
    meta: { title: "Эдеон | Папки" },
    component: () => import("@/views/localCategories/Edit.vue"),
  },
  {
    path: "/integration",
    meta: { title: "Эдеон | Интеграция" },
    component: () => import("@/views/integration/Edit.vue"),
  },
  {
    name: "partners",
    path: "/collaboration/partnership",
    meta: { title: "Эдеон | Партнёры" },
    component: () => import("@/views/collaboration/Partners.vue"),
  },
  {
    name: "coauthors",
    path: "/collaboration/coauthors",
    meta: { title: "Эдеон | Соавторы" },
    component: () => import("@/views/collaboration/Coauthors.vue"),
  },
  {
    name: "referral",
    path: "/collaboration/referral",
    meta: { title: "Эдеон | Реферальная программа" },
    component: () => import("@/views/collaboration/Referral.vue"),
  },
  {
    path: "/manage/help",
    meta: { title: "Эдеон | Помощь" },
    component: () => import("@/views/help/Help.vue"),
  },
  {
    path: "/manage/help/article",
    meta: { title: "Эдеон | Вопрос" },
    component: () => import("@/views/help/Article.vue"),
  },
  {
    path: "/manage/help/sections",
    meta: { title: "Эдеон | Разделы" },
    component: () => import("@/views/help/Sections.vue"),
  },

  /* MANAGE STATISTICS */
  {
    path: "/manage/statistics",
    meta: { title: "Эдеон | Статистика сервиса" },
    component: () => import("@/views/manageStatistics/Index.vue"),
    children: [
      /* GENERAL STATISTICS */
      {
        path: "/manage/statistics/general",
        meta: { title: "Эдеон | Общая статистика сервиса" },
        component: () => import("@/views/manageStatistics/General.vue"),
      },
      /* SELLS STATISTICS */
      {
        path: "/manage/statistics/sells",
        meta: { title: "Эдеон | Статистика продаж" },
        component: () => import("@/views/manageStatistics/Sells.vue"),
      },
      /* SELLERS STATISTICS */
      {
        path: "/manage/statistics/sellers",
        meta: { title: "Эдеон | Статистика продавцов" },
        component: () => import("@/views/manageStatistics/Sellers.vue"),
      },
      /* ALL SELLERS STATISTICS */
      {
        path: "/manage/statistics/all-sellers",
        meta: { title: "Эдеон | Статистика всех продавцов" },
        component: () => import("@/views/manageStatistics/AllSellers.vue"),
      },
    ],
  },

  {
    path: "/manage/support",
    meta: { title: "Эдеон | Тех. поддержка" },
    component: () => import("@/views/support/Index.vue"),
  },

  /* ITEM */
  {
    path: "/items",
    meta: { title: "Эдеон | Продукты" },
    component: () => import("@/views/item/Index.vue"),
  },
  {
    path: "/item/create",
    meta: { title: "Эдеон | Создание продукта" },
    component: () => import("@/views/item/Edit.vue"),
  },
  {
    path: "/item/:itemId/edit",
    meta: { title: "Эдеон | Редактирование продукта" },
    component: () => import("@/views/item/Edit.vue"),
  },

  // TODO: удалить гайды, так как не используются.
  /* GUIDES */
  {
    path: "/guide",
    meta: { title: "Эдеон | Гайды" },
    component: () => import("shared/views/article/Index.vue"),
    props: () => ({ mode: config.ARTICLE_MODES.GUIDE, baseUrl: "/guide" }),
  },
  {
    path: "/guide/create",
    meta: { title: "Эдеон | Гайд - Создание" },
    component: () => import("shared/views/article/Edit.vue"),
    props: () => ({ mode: config.ARTICLE_MODES.GUIDE, baseUrl: "/guide" }),
  },
  {
    path: "/guide/:articleId/content",
    meta: { title: "Эдеон | Гайд - Редактирование" },
    component: () => import("shared/views/article/Edit.vue"),
    props: () => ({ mode: config.ARTICLE_MODES.GUIDE, baseUrl: "/guide" }),
  },

  /* SHOP SETTINGS */
  {
    path: "/shop/settings",
    meta: { title: "Эдеон | Настройки магазина" },
    component: () => import("shared/views/settings/SettingsEdit.vue"),
  },

  /* LANDINGS */
  {
    path: "/landings",
    meta: { title: "Эдеон | Лендинги" },
    component: () => import("@/views/landings/Index.vue"),
  },
  {
    path: "/landing/:landingId/edit",
    meta: { title: "Эдеон | Редактирование лендинга" },
    component: () => import("@/views/landings/Edit.vue"),
  },

  /* TARIFFICATION */
  {
    path: "/tariffication",
    meta: { title: "Эдеон | Услуги и оплата" },
    component: () => import("@/views/tariffication/TarifficationIndex.vue"),
  }
);

export default sharedRoutes;
